<template>
	<div>
		<v-row>
			<v-col cols="6">
				<v-form ref="form" v-model="formIsValid" style="min-width: 300px">
					<div class="mb-4">
						<v-text-field
								v-model="user.first_name"
								class="rounded-lg required"
								hide-details="auto"
								label="First Name"
								outlined
								:rules="rules.firstName"
						></v-text-field>
					</div>
					<div class="mb-4">
						<v-text-field
								v-model="user.last_name"
								class="rounded-lg required"
								hide-details="auto"
								label="Last Name"
								outlined
								:rules="rules.lastName"
						></v-text-field>
					</div>
					<div class="mb-4">
						<v-text-field
								v-model="user.email"
								class="rounded-lg required"
								hide-details="auto"
								label="Email"
								outlined
								:rules="rules.email"
								type="email"
						></v-text-field>
					</div>
					<div class="mb-4">
						<v-select
								v-model="user.role_id"
								class="rounded-lg required"
								hide-details="auto"
								label="Role"
								:items="roles"
								item-text="name"
								item-value="id"
								outlined
						>
						</v-select>
					</div>
					<div class="mb-4">
						<vue-tel-input-vuetify
								ref="phone"
								v-model="user.phone"
								append-icon="mdi-menu-down"
								class="rounded-lg"
								clearable
								:defaultCountry="'US'"
								hide-details="auto"
								label="Phone"
								mode="international"
								outlined
								:preferred-countries="['us', 'ca']"
								:rules="rules.phone"
								@input="phoneInputEvent"
								@keydown="phoneKeyEvent"
						></vue-tel-input-vuetify>
					</div>
					<div class="mb-4">
						<vue-tel-input-vuetify
								ref="phone"
								v-model="user.secondary_phone"
								append-icon="mdi-menu-down"
								class="rounded-lg"
								clearable
								:defaultCountry="'US'"
								hide-details="auto"
								label="Secondary Phone"
								mode="international"
								outlined
								:preferred-countries="['us', 'ca']"
								:rules="rules.phone"
								@input="phoneInputEvent"
								@keydown="phoneKeyEvent"
						></vue-tel-input-vuetify>
					</div>
				</v-form>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-btn
						text
						class="rounded-md"
						:block="$vuetify.breakpoint.smAndDown"
						@click="exit"
				>Cancel
				</v-btn>
				<v-btn
						class="rounded-md"
						color="success"
						depressed
						:disabled="!formIsValid"
						:x-large="$vuetify.breakpoint.mdAndUp"
						@click="onSubmit"
				>
					{{ submitButtonTitle }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'NewUser',
	props: {
		user: {
			type: Object,
			default: () => ({})
		},
		roles: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({})
		},
		submitButtonTitle: {
			type: String,
			default: 'Submit'
		}
	},
	data() {
		return {
			formIsValid: false,
			rules: {
				email: [
					v => !!v || 'Email is required.',
					v => {
						const pattern =
								// eslint-disable-next-line max-len
								/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return pattern.test(v) || 'Please enter a valid e-mail.';
					}
				],
				firstName: [v => !!v || 'First name is required.'],
				lastName: [v => !!v || 'Last name is required.'],
				role: [v => !!v || 'Role is required.'],
			},
		};
	},
	computed: {},
	created() {
	},
	mounted() {
	},
	methods: {
		async save() {
			return new Promise(async resolve => {
				let url = `/admin-portal/${this.partner.id}/users/main/create-user`;
				axios.put(url, this.user).then(response => {
					window.EventBus.$emit('system-messages', [
						{
							message: 'User Created',
							messageType: 'success'
						}
					]);
					this.exit();
					resolve();
				}).catch(error => {
					window.EventBus.$emit('system-messages', [
						{
							message: error,
							messageType: 'error'
						}
					]);
					resolve();
				});
			});
		},
		async onSubmit() {
			if(!this.formIsValid)
				return;
			this.save();
		},
		exit() {
			window.location.href = '/admin-portal/' + this.partner.id + '/users/main/list-users';
		},
		phoneInputEvent(formattedNumber, { valid }) {
			// Only flip the form validity to false if NOT valid, do nothing on valid = true
			if(!valid) this.formIsValid = false;
		},
		phoneKeyEvent(e) {
			const validCharsRegex = new RegExp(/^[0-9 +\-()]*$/);

			// Allow Control+V or Command+V for pasting
			const isPasteOperation = (e.key === 'v' || e.key === 'V') && (e.ctrlKey || e.metaKey);

			if(!validCharsRegex.test(e.key) && ![
				'ArrowLeft',
				'ArrowRight',
				'Backspace',
				'Delete',
				'Tab'
			].includes(e.key) && !isPasteOperation) {
				e.preventDefault();
			}
		},
	}
};
</script>

<style lang="scss" scoped></style>